import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { throwError } from 'rxjs';
import { IDtoResponse } from '../models/dtos/response.dto';
import { NotificationService } from '../services/notification.service';

@Injectable({
  providedIn: 'root',
})
export class AppErrorHandler implements ErrorHandler {
  constructor(private readonly _notSvc: NotificationService, private readonly _authSvc: AuthService) {}

  handleError(exceptionResponse: HttpErrorResponse) {
    //FIXME Only for testing...
    //console.log(exceptionResponse);
    

    const { error }: { error: IDtoResponse<any> } = exceptionResponse;

    switch (exceptionResponse.status) {
      case 0:
        this._notSvc.openSnackBar(
          '0: Service Temporarily Unavailable',
          undefined,
          undefined,
          undefined,
          'error',
          ['snackbar-failure'],
          false
        );
        break;
      // case 400:
      //     this._snackBar.open(error.error.error.message, undefined, {
      //         duration: this.snack_bar_duration,
      //         panelClass: ['red-snackbar']
      //     });
      //    break;
      case 401:
        //this._notSvc.errorMessage(`${error.status}: ${error.message}`);
        this._notSvc.openSnackBar('401: Unauthorized', undefined, undefined, undefined, 'error', ['snackbar-failure'], false);
        this._authSvc.logout({ returnTo: window.location.origin });
        break;
      case 403:
        //... do somwthing
        //this._notSvc.errorMessage(`${error.status}: ${error.message}`);
        this._notSvc.openSnackBar('403: Forbidden', undefined, undefined, undefined, 'error', ['snackbar-failure'], false);
        this._authSvc.logout({ returnTo: window.location.origin });
        break;
      case 404: //Not Found
        //... do somwthing
        this._notSvc.openSnackBar(
          `${error.status}: ${error.message}`,
          undefined,
          undefined,
          undefined,
          'error',
          ['snackbar-failure'],
          false
        );
        break;
      //Internal Server Error
      // case 500:
      //   this._notSvc.errorMessage(`${exceptionResponse.status}: ${exceptionResponse.url}`);
      //   break;
      default:
        this._notSvc.errorMessage(`[${exceptionResponse.status}] ${exceptionResponse.url}`);

        break;
    }

    return throwError(() => error);
    //return throwError(() => new Error(error.error.error));
  }
}
